<script lang="ts">
	interface Props {
		links: Array<string>
	}

	let { links }: Props = $props()
</script>

<div class="subscription-links">
	<p>You have multiple different subscriptions, you can manage using the links below:</p>
	<ul>
		{#each links as link}
			<li>
				<a href={link} target="_blank">{link}</a>
			</li>
		{/each}
	</ul>
</div>

<style>
	.subscription-links {
		overflow-y: auto;
	}

	p {
		color: var(--color-text);
		margin-bottom: 0;
	}

	li::before {
		content: "‣";
		margin-right: 0.25rem;
	}

	a {
		border-bottom: 0;
		color: var(--color-main);
	}
</style>
